<template>
  <v-container
    id="candidateRegistrationBackground"
    fluid
  >
    <v-row class="d-flex flex-column flex-md-row align-md-center row-hero">
      <!-- LEFT on md+: Password reset -->
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center full-height order-md-1"
      >
        <div class="form-wrap">
          <password-reset-component
            :email="email"
            :token="token"
            :iscandidate="iscandidate"
          />
        </div>
      </v-col>

      <!-- RIGHT on md+: Logo -->
      <v-col
        cols="12"
        md="6"
        class="d-flex align-center justify-center full-height order-md-2"
      >
        <img
          v-if="tenant.settings.logo === null"
          src="/img/logo.svg"
          alt="Flo Logo"
          class="logo-size"
        >
        <img
          v-else
          src="/agency-file/logo"
          alt="Tenant Logo"
          class="logo-size"
        >
      </v-col>
    </v-row>
    <p class="bottom-right">
      <a
        href="https://flo.co.uk"
        title="Recruitment Software by Flo"
        target="_blank"
      >Recruitment Software by Flo</a>
    </p>
  </v-container>
</template>
<script>
import PasswordResetComponent from './PasswordResetComponent.vue'
export default {
  name: 'CandidateRegistrationBackground',
  components: { PasswordResetComponent },
  props: {
    tenant: {
      type: Object,
      default: () => {
        return {}
      }
    },
    email: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    iscandidate: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    //
  }),
  computed: {
    //
  },
  created () {
    //
  },
  methods: {
    //
  }
}
</script>
<style lang="scss">

/* Make the row tall enough to center vertically on md+ */
#candidateRegistrationBackground .row-hero {
  /* mobile stacks naturally */
}
@media (min-width: 960px) {
  #candidateRegistrationBackground .row-hero {
    min-height: 100vh; /* enables vertical centering */
  }
}

/* Optional: a nice, consistent width for the reset form */
#candidateRegistrationBackground .form-wrap {
  width: min(92vw, 520px);
}

/* Logo stays responsive */
#candidateRegistrationBackground .logo-size {
  width: auto;
  max-width: min(90vw, 560px);
  max-height: clamp(80px, 18vh, 180px);
  object-fit: contain;
}
@import './resources/sass/variables';
#candidateRegistrationBackground {
  .bottom-right {
    color: grey;
    position: fixed;
    bottom : 0;
    right: 1rem;
  }
  .bottom-right a {
    text-decoration: none;
    color: grey;
  }
  .pab {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .logo-size{
    width: auto;
  }
  .register-comp{
    max-width: 95vw;
    max-height: 95vh;
  }
  @media screen and (max-width: 960px){
    .bottom-right {
      display: none;
    }
  }
  @media screen and (min-width: 960px){
    .full-height{
      height: 100vh;
    }
    .logo-size{
      width: auto;
    }
  }
  .parallelogram {
    position: fixed;
    bottom: -10%;
    left: 0;
    width: 100vw;
    height: 70vh;
    min-height: 600px;
    background-color: $agencyColorPrimary;
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      width: 600px;
      height: 100vh;
    }
    @media screen and (min-width: 1200px) {
      width: 50vw;
    }
  }
  .parallelogram2 {
    position: fixed;
    bottom: -80%;
    left: 0;
    width: 100vw;
    height: 80vh;
    background-color: $agencyColorSecondary;
    box-shadow: 6px 0px 10px 5px rgba(0,0,0,0.1);
    @media screen and (min-width: 960px) {
      bottom: 0;
      left: -50%;
      width: 600px;
      height: 100vh;
    }
    @media screen and (min-width: 1200px) {
      left: -50%;
      width: 52vw;
    }
  }
}
</style>
